import {Pipe, PipeTransform} from '@angular/core';
import {AsYouType, format, parse} from 'libphonenumber-js';

@Pipe({
    name: 'phoneNumber',
    standalone: true
})
export class PhoneNumberPipe implements PipeTransform {
  transform(value: string, showValidation?: boolean): string {
    if (!value) {
      return value;
    }

    let phoneNumber = parse(value, {defaultCountry: 'US', extended: true});

    if (phoneNumber.valid) {
      if (phoneNumber.country === 'US') {
        return format(phoneNumber, 'NATIONAL');
      } else {
        return format(phoneNumber, 'INTERNATIONAL');
      }
    }

    if (showValidation) {

      if (value.length < 10) {
        return new AsYouType('US').input(value) + (' (invalid)');
      }

      let formatted = value;

      try {
        formatted = format(phoneNumber, 'INTERNATIONAL') + (' (invalid)');
      } catch (e) {
        console.error(e, value, formatted);
      }

      return formatted;
    } else {
      phoneNumber = parse(`+1${value}`, {defaultCountry: 'US', extended: true});
      if (!phoneNumber.valid) {
        phoneNumber = parse(`+${value}`, {defaultCountry: 'US', extended: true});
      }

      if (phoneNumber.valid) {
        if (phoneNumber.country === 'US') {
          return format(phoneNumber, 'NATIONAL');
        } else {
          return format(phoneNumber, 'INTERNATIONAL');
        }
      }
    }

    return value;
  }
}
